<template>
  <ValidationProvider
    :rules="required ? { required: true } : {}"
    v-slot="{ classes, errors }"
    tag="div"
    role="radiogroup"
  >
    <div v-for="(option, i) in normalizedOptions"
      :key="option.value"
      class="form-check"
      role="presentation"
    >
      <label class="form-label form-check-label">
        <input
          type="radio"
          :name="uniqName('radio-buttons')"
          :aria-label="option.label"
          :aria-invalid="errors.length ? 'true' : 'false'"
          :aria-required="required"
          autocomplete="off"
          :class="['form-check-input', ...classes]"
          :value="option.value"
          v-bind="$attrs"
          v-model="model"
          @focus="onFocus(i)"
          @blur="onBlur"
          ref="option"
        >
        {{ option.label }}
      </label>
    </div>
  </ValidationProvider>
</template>

<script>
import focusable from '@ssi/vue-common/src/mixins/focusable';
import { defaultSchema } from '@ssi/vue-common/src/directives/focus';
import { hasProps } from '@/helpers/util';

const { prop: focusProp } = defaultSchema;

export default {
  mixins: [focusable],

  props: {
    options: {
      type: Array,
      required: true
    },

    required: {
      type: Boolean,
      default: () => false
    },

    value: [Boolean, String]
  },

  data: () => ({
    focusedOptionIndex: -1
  }),

  computed: {
    model: {
      get: ({ value }) => value,
      set(newValue) {
        this.$emit('input', newValue);
      }
    },

    normalizedOptions: ({ options }) => options.map(o => (hasProps(o, ['value', 'label'])
      ? o
      : {
        value: o,
        label: o !== null ? String(o) : ''
      })),

    selectedOptionIndex: ({ model, options }) =>
      options.findIndex(o => model === o.value)
  },

  methods: {
    onBlur() {
      this.focusedOptionIndex = -1;
      this.hasFocus = false;
    },

    onFocus(i) {
      this.focusedOptionIndex = i;
      this.hasFocus = true;
    }
  },

  watch: {
    [focusProp](val) {
      if (val && this.focusedOptionIndex === -1) {
        this.$refs.option[(this.selectedOptionIndex || 0)]?.focus();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.form-label {
  border-radius: 0.3rem;
  cursor: pointer;
  margin-bottom: 0;
  margin-left: -2.25em;
  padding: 0.25em 1em 0.25em 2.25em;
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background-color: $primary-light;
  }
}
</style>
